import { combineReducers } from 'redux';
import types from './types';

/* State Shape
{
}
*/

const reducer = combineReducers({});

export default reducer;
